import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { styled } from "styled-components";
import Theme from "../../../../styles/Theme/Theme";
import { Footer } from "../../../App/Footer";
import { Sidebar } from "../../../App/SideBar";
import { RegistryItemHeader } from "../../Molecules/BuildingDetails/RegistryItemHeader";

//#region Styled Components
const DetailWrapper = styled.div`
  display: flex;
  flex-direction: row;
  min-height: 100%;
  background-color: ${Theme.color["neutral-1"]};
`;

const RightContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: calc(100% - 235px);
  overflow-y: auto;
  .tab_component_children {
    padding: ${Theme.spacing.s05};
    box-sizing: border-box;
  }
`;
//#endregion

export const RegisterComponent = ({ item, tabsHelper }) => {
  const { id, mainTab, subTab } = useParams();
  const navigate = useNavigate();
  const tags = JSON.parse(localStorage.getItem("unified_nova_tags"));

  // Define the initial values based on the URL and the tabs available to the user
  const defaultTab =
    tabsHelper?.find(tab => tags.includes(tab.label))?.path || "";

  const initialTab =
    mainTab && tabsHelper.some(tab => tab.path === mainTab)
      ? mainTab
      : defaultTab;

  const tabItem = tabsHelper?.find(entry => entry.path === initialTab);

  const initialSubTab =
    tabItem?.subTabsPath?.includes(subTab) ? subTab : tabItem?.subTabsPath?.[0];

  // State to manage navigation
  const [navState, setNavState] = useState({
    currentTab: initialTab,
    headerSelectedTab: initialSubTab,
    currentFloor: null,
  });

  // When the navigation state changes, sync the URL
  useEffect(() => {
    const { currentTab, headerSelectedTab } = navState;
    if (currentTab !== mainTab || headerSelectedTab !== subTab) {
      navigate(`/registry/item/${id}/${currentTab}/${headerSelectedTab}`, {
        replace: true,
      });
    }
  }, [navState, id, mainTab, subTab, navigate]);

  /**
   * Handles the tab change event.
   * Switches the current tab and resets the subtab to the first
   *
   * @param {string} tab - The label of the tab to switch to.
   */
  const handleTabChange = (tab) => {
    const newTabItem = tabsHelper.find(entry => entry.path === tab);
    if (newTabItem) {
      setNavState(prev => ({
        ...prev,
        currentTab: tab,
        headerSelectedTab: newTabItem.subTabsPath[0],
      }));
    }
  };

  // Determine the component to be rendered according to the selected subtab
  const currentTabItem = tabsHelper?.find(
    entry => entry.path === navState.currentTab
  );

  const headerTabIndex = currentTabItem?.subTabsPath.findIndex(
    tab => tab === navState.headerSelectedTab
  );

  const OpenTabComponent =
    headerTabIndex >= 0 ? currentTabItem.component[headerTabIndex] : null;

  return (
    <DetailWrapper>
      <Sidebar
        sideBarMenu={tabsHelper?.filter(item => tags.includes(item.label))}
        activeTab={navState.currentTab}
        setCurrentTab={handleTabChange}
      />
      {currentTabItem && tags.includes(currentTabItem.label) && (
        <RightContent>
          <div>
            <RegistryItemHeader
              item={item}
              buttons={currentTabItem?.buttons}
              changeHeaderSelectedTab={(sub) =>
                setNavState(prev => ({
                  ...prev,
                  headerSelectedTab: sub,
                }))
              }
              changeHeaderFloor={(floor) =>
                setNavState(prev => ({
                  ...prev,
                  currentFloor: floor,
                }))
              }
              hideHeaderDropdown={
                currentTabItem?.hideHeader?.includes(navState.headerSelectedTab) ??
                false
              }
              headerSelectedTab={navState.headerSelectedTab}
              subTabPath={tabItem.subTabsPath}
            />
            {OpenTabComponent && (
              <OpenTabComponent
                item={item}
                currentFloor={navState.currentFloor}
                headerSelectedTab={navState.headerSelectedTab}
                className="tab_component_children"
              />
            )}
          </div>
          <Footer />
        </RightContent>
      )}
    </DetailWrapper>
  );
};